import { styled } from '@mui/material';

import { formatShortDate } from '@app-velocity/common';

import { Typography, Box } from '@app-velocity/ui';

import { FileIcon, GlobeIcon, PrototypesIcon } from '@app-velocity/icons';

import { useReportContext } from '../../../../context/useReportContext';

const StyledDetails = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
}));

const DetailText = styled(Typography)({
  fontWeight: 300,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

const DetailLine = styled('div')(({ theme }) => ({
  display: 'flex',
  fontWeight: 300,
  alignItems: 'center',
  gap: theme.spacing(1),
  svg: {
    fill: '#7a7a7a',
    flex: '0 0 auto',
  },
}));

export const ReportDetails = () => {
  const { data } = useReportContext();

  if (!data) return null;

  const { created, name, fileName, pageName, url } = data;

  return (
    <StyledDetails>
      <DetailLine>{created ? formatShortDate(created) : '-'}</DetailLine>
      {fileName ? (
        <DetailLine>
          <FileIcon />
          <DetailText>{fileName || '-'}</DetailText>
        </DetailLine>
      ) : null}
      {pageName ? (
        <DetailLine>
          <FileIcon />
          <DetailText>{pageName || '-'}</DetailText>
        </DetailLine>
      ) : null}
      {name ? (
        <DetailLine>
          <PrototypesIcon />
          <DetailText>{name || '-'}</DetailText>
        </DetailLine>
      ) : null}
      {url ? (
        <DetailLine>
          <GlobeIcon />
          <DetailText>{url || '-'}</DetailText>
        </DetailLine>
      ) : null}
    </StyledDetails>
  );
};
